import React from 'react';

import { PolicyContainer, PolicySection } from './CancellationPolicy.styled';
import { Text } from 'components/v2/Typography/Text';
import { currencyNumberFormat } from 'utilities/number-format';

import { CancellationPolicyProps } from './CancellationPolicy.types';
import { NavigatorEmail } from './NavigatorEmail';
import { NavigatorNumber } from './NavigatorNumber';

const getLateCancellationCopy = ({
  lateCancelWindowHours,
  lateCancelFeeCents
}: Pick<CancellationPolicyProps, 'lateCancelWindowHours' | 'lateCancelFeeCents'>) => {
  if (lateCancelWindowHours != null && lateCancelFeeCents != null) {
    return `Late Cancellation: If you cancel within ${lateCancelWindowHours} hours of your appointment, a ${currencyNumberFormat(
      lateCancelFeeCents / 100
    )} late cancellation fee may apply.`;
  }

  return 'Late Cancellation: If you cancel within the designated timeframe as stated in our cancellation policy, a late cancellation fee may apply.';
};

export const CancellationPolicy = ({
  emailBody,
  noCancelNorRescheduleVariant,
  lateCancelWindowHours,
  lateCancelFeeCents,
  noShowFeeCents
}: CancellationPolicyProps): React.JSX.Element => {
  return (
    <PolicyContainer>
      <PolicySection>
        <Text tag="p" fontStyle="semibold">
          Cancellation/No-Show Policy:
        </Text>
        {!noCancelNorRescheduleVariant && (
          <Text tag="p">
            To reschedule or cancel: Please make any changes through the patient portal.
          </Text>
        )}
        <Text tag="p">
          {getLateCancellationCopy({
            lateCancelWindowHours,
            lateCancelFeeCents
          })}
        </Text>
        <Text tag="p">
          {noShowFeeCents != null ? (
            <>
              No-Show: If you miss your appointment without canceling, a{' '}
              {currencyNumberFormat(noShowFeeCents / 100)} no-show fee will apply.
            </>
          ) : (
            'No-Show: If you miss your appointment without canceling, a no-show fee may apply.'
          )}
        </Text>
      </PolicySection>
      <p>
        <Text>
          If you need assistance rescheduling or canceling outside the portal, please contact us
          at{' '}
        </Text>
        <NavigatorNumber />
        <Text> or email us at </Text>
        <NavigatorEmail emailBody={emailBody} />
        <Text>.</Text>
      </p>
    </PolicyContainer>
  );
};
